export default {
  set(state, { data }) {
    state.modulos = data;
  },
  show(state, { data }) {
    state.modulo = data;
  }
}